"use client";

import React from "react";
import { useGlobalChat } from "../contexts/ChatContext";

interface ChatToggleButtonProps {
  config?: {
    position?: {
      placement?: "top-left" | "top-right" | "bottom-left" | "bottom-right";
      offsetX?: string;
      offsetY?: string;
    };
  };
}

const ChatToggleButton: React.FC<ChatToggleButtonProps> = ({ config = {} }) => {
  const { toggleChat } = useGlobalChat();

  // Style variables based on position
  const positionClasses = (() => {
    const position = config?.position?.placement || "bottom-right";

    switch (position) {
      case "top-left":
        return "top-5 left-5";
      case "top-right":
        return "top-5 right-5";
      case "bottom-left":
        return "top-5 left-5";
      case "bottom-right":
      default:
        return "bottom-5 right-5";
    }
  })();

  return (
    <button
      onClick={toggleChat}
      className={`fixed ${positionClasses} z-50 w-14 h-14 bg-blue-500 hover:bg-blue-600 text-white rounded-full flex items-center justify-center shadow-lg transition-transform duration-300 ease-in-out hover:scale-105 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500`}
      aria-label="Toggle chat"
    >
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      >
        <path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z"></path>
      </svg>
    </button>
  );
};

export default ChatToggleButton;
